/**
 * Determines the active auth provider based on a cookie value.
 * Cookie `auth_provider=keycloak` enables Keycloak;
 */
export function isKeycloakAuth(): boolean {
  if (!process.client) {
    return false
  }

  const cookies = document.cookie.split(';')
  return cookies.some(c => c.trim() === 'auth_provider=keycloak')
}
